import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import { PublicHeader } from '../common';
import api from '../../services/api';
import IndigoPriceList from './IndigoPriceList';
import './PricingPage.css';

const PricingPage = () => {
  const { t } = useLanguage();
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const url = `${api.baseUrl}/pricing/download/`;
      const token = api.getToken();
      const headers = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      const response = await fetch(url, { method: 'GET', headers });
      if (!response.ok) {
        let errorText = t('pricing.downloadError') || 'Failed to download price list';
        try {
          const errorData = await response.json();
          errorText = errorData.errorText || errorText;
        } catch (e) {}
        throw new Error(errorText);
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'service-rates(CNY).pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error('Error downloading pricing PDF:', err);
      alert(err.message || t('pricing.downloadError') || 'Failed to download price list');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <PublicHeader />
      <Container className="py-5 pricing-page">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <h1 className="h4 mb-1 fw-bold">{t('pricing.title')}</h1>
            <p className="text-muted small mb-0">{t('pricing.subtitle')}</p>
          </div>
          <button
            type="button"
            onClick={handleDownload}
            disabled={downloading}
            className="btn btn-outline-primary btn-sm px-4 pricing-download-btn"
          >
            {downloading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                {t('pricing.downloading')}
              </>
            ) : (
              <>
                <i className="bi bi-download me-2" />
                {t('pricing.downloadButton')}
              </>
            )}
          </button>
        </div>
        <IndigoPriceList />
      </Container>
    </>
  );
};

export default PricingPage;
